import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { qmsService } from '../qms/qms.service';
import { MatCalendar, MatCalendarCellCssClasses } from '@angular/material/datepicker';
import { DomSanitizer } from '@angular/platform-browser';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { CalendarEvent, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { isSameDay, isSameMonth } from 'date-fns';
import { CalendarOptions } from '@fullcalendar/core';
import timeGridPlugin from '@fullcalendar/timegrid'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction';
import { AuService } from '../qms/au/au.service';
import { CoreNavigationService } from 'src/app/support/navigation/core-navigation.service';


@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})

export class CalendarComponent implements OnInit, AfterViewInit {

  isProcessing: boolean = false;
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  constructor(
    public dialog: MatDialog,
    private readonly modal: NgbModal,
    readonly coreNavigationService: CoreNavigationService,
    private readonly appService: AppService,
    public router: Router,
    public domSanitizer: DomSanitizer,
    public message: messageService,
    public qualityService: qmsService,
    private readonly renderer: Renderer2,
    public auService: AuService,
  ) {
    this.message.breadcrumbData.firstLevel = "Home";
  }

  calendarEvent: any = [];
  prevCalendarEvent: any = [];
  nextCalendarEvent: any = [];
  isShowCalendar: any;
  today: any;
  dateSearch1: any;
  dateSearch2: any;
  todayCount = 0;
  todaysOverdueEventDetails: any = [];
  todaysTRNEventDetails: any = [];
  todaysDMSEventDetails: any = [];
  todaysQMSEventDetails: any = [];
  todayDate = new Date();
  datePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  dateCustomClasses: DatepickerDateCustomClasses[];
  feedbackTemplateList: [];

  ngOnInit(): void {
    this.appService.getFeedbackTemplatesList().subscribe((data: any) => {
      this.feedbackTemplateList = data;
    })

    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    let month = this.months[new Date().getMonth()];
    this.calPrivNextMont(new Date());

    this.today = ('0' + new Date().getDate()).slice(-2) + '-' + month.toUpperCase() + '-' + new Date().getFullYear();
    this.selectedDate = this.today;
    this.isShowCalendar = false;
    this.calendarEvent = JSON.parse(sessionStorage.getItem('calendarData') || '[]');
    for (const element of this.calendarEvent) {
      let monthForEvent = this.months[new Date(element.startDate).getMonth()];
      element.startDate = ('0' + new Date(element.startDate).getDate()).slice(-2) + '-' + monthForEvent.toUpperCase() + '-' + new Date(element.startDate).getFullYear();
      let monthForEvent1 = this.months[new Date(element.endDate).getMonth()];
      element.endDate = ('0' + new Date(element.endDate).getDate()).slice(-2) + '-' + monthForEvent1.toUpperCase() + '-' + new Date(element.endDate).getFullYear();
    }

    this.isProcessing = true;
    this.appService.getCalendarTodayEventDetails().subscribe((data: any) => {
      this.isProcessing = false;
      this.todaysOverdueEventDetails = data;
      this.buildSummaryEvents();
      this.isShowCalendar = true;

    })
    this.isProcessing = true;
    this.todaysTRNEventDetails = [];
    this.todaysDMSEventDetails = [];
    this.todaysQMSEventDetails = [];
    this.appService.getTodayEventDetails().subscribe((data: any) => {
      this.isProcessing = false;
      for (const element of data) {
        if (element.moduleCode == "TRN" || element.moduleCode == "My Trainings" || element.moduleCode == "INSTTRN") {
          this.todaysTRNEventDetails.push(element);
        } else if (element.moduleCode == "DMS") {
          this.todaysDMSEventDetails.push(element);
        } else {
          this.todaysQMSEventDetails.push(element);
        }
      }
    })
  }

  private parseApiDate(dateStr: string): Date | null {
    if (!dateStr) return null;

    // Split "27-Dec-2024 17:20:33"
    const [datePart, timePart] = dateStr.split(' ');
    if (!datePart) return null;

    const [day, mon, year] = datePart.split('-');
    const monthIndex = this.months.findIndex(
      m => m.toUpperCase() === mon.toUpperCase()
    );

    if (monthIndex < 0) return null;

    // If time exists, split it
    let hours = 0, minutes = 0, seconds = 0;
    if (timePart) {
      const [h, m, s] = timePart.split(':');
      hours = Number(h);
      minutes = Number(m);
      seconds = Number(s);
    }

    return new Date(Number(year), monthIndex, Number(day), hours, minutes, seconds);
  }


  groupedEventsByDate: any;
  private buildSummaryEvents() {
    const groups: any = {};

    for (const el of this.todaysOverdueEventDetails) {

      if (!el.startDate) continue;

      const key = el.startDate.split(" ")[0];

      if (!groups[key]) groups[key] = [];
      groups[key].push(el);
    }


    this.groupedEventsByDate = groups;

    this.events = [];

    for (const key of Object.keys(groups)) {

      const count = groups[key].length;
      const label = count === 1 ? 'Event' : 'Events';
      const d = this.parseApiDate(key + " 00:00:00");
      this.events.push({
        start: d,
        end: d,
        title: `${count} ${label}`,
        allDay: true
      });
    }

    this.calendarOptions = {
      ...this.calendarOptions,
      events: [...this.events]
    };
  }



  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  dateClass() {

    return (date: Date): MatCalendarCellCssClasses => {

      //search in the array
      const items = this.calendarEvent?.find((x: any) => new Date(x.startDate) <= date && new Date(x.endDate) >= date);
      //return if found it, the "type", else null
      return [items ? 'linkableTMS' : ''];

    };
  }

  selectedDate: any = null;
  onSelect(event: any) {
    let month = this.months[event.getMonth()];
    this.selectedDate = ('0' + event.getDate()).slice(-2) + '-' +
      month.toUpperCase() + '-' +
      event.getFullYear();

    this.todaysOverdueEventDetails = [];
    if (this.selectedDate == this.today) {
      this.isProcessing = true;
      this.isProcessing = true;
      this.todaysTRNEventDetails = [];
      this.todaysDMSEventDetails = [];
      this.todaysQMSEventDetails = [];
      this.appService.getTodayEventDetails().subscribe((data: any) => {
        this.isProcessing = false;
        for (const element of data) {
          if (element.moduleCode == "TRN" || element.moduleCode == "My Trainings" || element.moduleCode == "INSTTRN") {
            this.todaysTRNEventDetails.push(element);
          } else if (element.moduleCode == "DMS") {
            this.todaysDMSEventDetails.push(element);
          } else {
            this.todaysQMSEventDetails.push(element);
          }
        }
      })
    }
  }

  monthChanged(event: any): void {
    //  'monthChanged' is empty
  }

  ngAfterViewInit() {
    const monthPrevBtn = document.querySelectorAll(
      '.mat-calendar-previous-button'
    );
    const monthNextBtn = document.querySelectorAll('.mat-calendar-next-button');

    if (monthPrevBtn) {
      Array.from(monthPrevBtn).forEach((button) => {
        this.renderer.listen(button, 'click', () => {
        });
      });
    }

    if (monthNextBtn) {
      Array.from(monthNextBtn).forEach((button) => {
        this.renderer.listen(button, 'click', () => {
        });
      });
    }
  }

  @ViewChild(MatCalendar) calendar: MatCalendar<any>;
  handlePreviousClicked() {
    this.calendarEvent = this.prevCalendarEvent;
    this.isProcessing = true;
    this.calPrivNextMont(this.calendar.activeDate);
    let obj = {

      date: this.dateSearch1,
    }
    this.appService.getCalendarEvent(obj).subscribe((data: any) => {

      this.prevCalendarEvent = data;
      for (const element of this.prevCalendarEvent) {
        let monthForEvent = this.months[new Date(element.dueOn).getMonth()];
        element.dueOn = ('0' + new Date(element.dueOn).getDate()).slice(-2) + '-' + monthForEvent.toUpperCase() + '-' + new Date(element.dueOn).getFullYear();
      }
      let obj1 = {

        date: this.dateSearch2,
      }
      this.appService.getCalendarEvent(obj1).subscribe((data: any) => {
        this.isProcessing = false;
        this.nextCalendarEvent = data;
        for (const element of this.nextCalendarEvent) {
          let monthForEvent = this.months[new Date(element.dueOn).getMonth()];
          element.dueOn = ('0' + new Date(element.dueOn).getDate()).slice(-2) + '-' + monthForEvent.toUpperCase() + '-' + new Date(element.dueOn).getFullYear();
        }
      })
    })
  }

  handleNextClicked() {
    this.calendarEvent = this.nextCalendarEvent;
    this.isProcessing = true;
    this.calPrivNextMont(this.calendar.activeDate);

    this.isProcessing = true;
    let obj2 = {

      date: this.dateSearch2,
    }
    this.appService.getCalendarEvent(obj2).subscribe((data: any) => {
      this.nextCalendarEvent = data;
      for (const element of this.nextCalendarEvent) {
        let monthForEvent = this.months[new Date(element.dueOn).getMonth()];
        element.dueOn = ('0' + new Date(element.dueOn).getDate()).slice(-2) + '-' + monthForEvent.toUpperCase() + '-' + new Date(element.dueOn).getFullYear();
      }
      let obj1 = {

        date: this.dateSearch1,
      }
      this.appService.getCalendarEvent(obj1).subscribe((data: any) => {
        this.isProcessing = false;
        this.prevCalendarEvent = data;
        for (const element of this.prevCalendarEvent) {
          let monthForEvent = this.months[new Date(element.dueOn).getMonth()];
          element.dueOn = ('0' + new Date(element.dueOn).getDate()).slice(-2) + '-' + monthForEvent.toUpperCase() + '-' + new Date(element.dueOn).getFullYear();
        }
      })
    })
  }

  calPrivNextMont(date: any) {
    if (date.getMonth() == 0) {
      let monthPriv = this.months[11];
      this.dateSearch1 = ('01') + '-' +
        monthPriv.toUpperCase() + '-' +
        (date.getFullYear() - 1)
    } else {
      let monthPriv = this.months[date.getMonth() - 1];
      this.dateSearch1 = ('01') + '-' +
        monthPriv.toUpperCase() + '-' +
        date.getFullYear()
    }

    if (date.getMonth() == 11) {
      let monthNext = this.months[0];
      this.dateSearch2 = ('01') + '-' +
        monthNext.toUpperCase() + '-' +
        (date.getFullYear() + 1)
    } else {
      let monthNext = this.months[date.getMonth() + 1];
      this.dateSearch2 = ('01') + '-' +
        monthNext.toUpperCase() + '-' +
        date.getFullYear()
    }
  }

  goToMyTask(event: any) {
    event.preventDefault();
    this.appService.setRouteOfMyTask("All");
    this.router.navigate(['/dashboard/MyTasks']);
  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true,
  };

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  view: CalendarView = CalendarView.Week;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  choosenView = 'week';
  setView(view: CalendarView) {
    this.view = view;
    this.choosenView = view;
  }
  events: any = [];

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent: CalendarEvent<any>) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    this.modal.open(this.modalContent, { size: 'lg' });
  }

  refresh = new Subject<void>();

  activeDayIsOpen: boolean = true;

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  takeGradientColor(): string {
    const gradientColor = 'linear-gradient(to right, red, orange, yellow)';
    return gradientColor;
  }

  @ViewChild('calendarWrapper') calendarWrapper!: ElementRef;
  relativePos = { x: 0, y: 0 };

  isShowPopup: boolean = false;

  handleDateClick1(arg: any) {
    //alert('date click! ' + arg.dateStr)
    let month = new Date(arg.date).getMonth() + 1;
    let date = new Date(arg.date).getDate() + "-" + month + "-" + new Date(arg.date).getFullYear();
    let month1 = this.months[new Date(arg.date).getMonth()];

    this.today = ('0' + new Date(arg.date).getDate()).slice(-2) + '-' + month1.toUpperCase() + '-' + new Date(arg.date).getFullYear();
    this.selectedDate = this.today;
    this.isProcessing = true;
    this.todaysTRNEventDetails = [];
    this.todaysDMSEventDetails = [];
    this.todaysQMSEventDetails = [];

    setTimeout(() => {
      const rect = this.calendarWrapper.nativeElement.getBoundingClientRect();

      this.relativePos = {
        x: arg.jsEvent.clientX - rect.left,
        y: arg.jsEvent.clientY - rect.top
      };
    });
    this.appService.getSelectedDateEventDetails(date).subscribe((data: any) => {
      for (const element of data) {
        if (element.moduleCode == "TRN" || element.moduleCode == "My Trainings" || element.moduleCode == "INSTTRN") {
          this.todaysTRNEventDetails.push(element);
        } else if (element.moduleCode == "DMS") {
          this.todaysDMSEventDetails.push(element);
        } else {
          this.todaysQMSEventDetails.push(element);
        }
      }
      this.isShowPopup = true;
      this.isProcessing = false;
    })
  }

  todaysEventArray: any = [];
  handleDateClick(arg: any) {
    const clicked = arg.date;

    const day = String(clicked.getDate()).padStart(2, '0');

    const rawMon = this.months[clicked.getMonth()];
    const mon = rawMon.charAt(0).toUpperCase() + rawMon.slice(1).toLowerCase();

    const year = clicked.getFullYear();

    const key = `${day}-${mon}-${year}`;

    this.todaysEventArray = this.groupedEventsByDate[key] || [];

    if (this.todaysEventArray.length) {
      setTimeout(() => {
        const rect = this.calendarWrapper.nativeElement.getBoundingClientRect();

        this.relativePos = {
          x: arg.jsEvent.clientX - rect.left,
          y: arg.jsEvent.clientY - rect.top
        };
      });

      this.isShowPopup = true;
    }
    console.log("Clicked Date:", key);
    console.log("Events on this day:", this.todaysEventArray);

  }

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],

    dateClick: (arg) => this.handleDateClick(arg),

    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: ''
      /* right: 'dayGridMonth,timeGridWeek,timeGridDay' */
    },

    views: {
      dayGrid: {
        dayMaxEventRows: 3
      }
    },

    allDayText: 'All-Day',
    events: this.events,

    eventDidMount: (info) => {
      info.el.classList.add('count-event');
      info.el.style.pointerEvents = 'none'; // <<< KEY LINE
    },

    eventMouseEnter: (info) => {
      info.el.style.cursor = 'default'; // event no click
    },

    dayCellDidMount: (arg) => {
      arg.el.style.cursor = 'pointer'; // entire cell clickable
    },

    eventClick: (info) => {
      info.jsEvent.stopPropagation(); // prevent eventClick
    },

    dayHeaderClassNames: () => ['header-bg'],

    datesSet: (arg) => this.handleMonthChange(arg),
  };

  handleMonthChange(arg: any) {
    const start = arg.start;
    const end = arg.end;

    console.log("Visible Calendar Range:", start, "to", end);
    this.isShowPopup = false;

    // 👉 You can call API here
    // this.loadEventsForRange(start, end);

    // 👉 Clear popup, refresh UI, anything
  }


  navigate(list: any) {

    this.isShowPopup = false;
    if (list.eventType == "Training") {
      this.coreNavigationService.calenderNavigation = 'Training';
      this.navigateToTrainingDashboard();
    } else if (list.eventType == "Audit") {
      this.navigateToAudit(list);
    }

  }

  private navigateToAudit(list: any): void {
    this.isProcessing = true;
    this.auService.auditPageFrom = "MyTask";
    this.qualityService.moduleName = "AU";
    this.appService.getAuByAuNo(list.eventId).subscribe((audit: any) => {
      if (this.auService.auditScheduleStatusList.includes(audit.status)) {
        this.navigateToSchedule(audit);
      } else if (this.auService.auditPlanStatusList.includes(audit.status)) {
        this.navigateToPlan(audit);
      } else {
        this.navigateToConduct(audit);
      }
    });
  }

  private navigateToSchedule(audit: any): void {
    this.auService.tabName = "Annual Audit Schedule";
    this.auService.list = {};
    this.message.activityId = this.qualityService.activityId = this.auService.list.AU_NO = audit.auNo;
    this.qualityService.selectedGroup = this.qualityService.selectedActivityGroupId = this.auService.list.GROUP_ID = audit.groupId;
    this.message.breadcrumbData.fourthLevel = this.auService.list.AU_ID = audit.auId;
    this.qualityService.activity = {};
    this.qualityService.activity.status = this.auService.list.STATUS = audit.status;
    this.qualityService.getQmsActionDataUsingById = {};
    this.appService.getQmsGroupsByModule("AU").subscribe((response1: any) => {
      const dropDownForAuditGroup: any[] = response1;
      this.auService.priorGroup = dropDownForAuditGroup.find((item: any) => item.groupId == audit.groupId);
      let group: any;
      this.qualityService.groupNameAndValue = group = [{
        displayExp: this.auService.priorGroup?.groupId,
        valueExp: this.auService.priorGroup?.groupName
      }];
      this.message.breadcrumbData.secondLevel = "Audit" + " > " + group?.groupName;
      this.qualityService.auditEditmodeDatas = { pageName: "Annual Audit Schedule" };
      this.isProcessing = false;
      this.coreNavigationService.calenderNavigation = 'Audit Grid';
    });
  }

  private navigateToPlan(audit: any): void {
    this.appService.getQmsGroupDetailsByModule(audit.groupId, 'AU').subscribe((data1: any) => {
      this.qualityService.selectedGroupDetailData = data1;
    });
    this.appService.getQmsActiveUserByGroupIdModuleUserId(audit.groupId, 'AU').subscribe((response1: any) => {
      this.qualityService.userRole = response1;
      const selectedGroupValue = [{
        valueExp: this.qualityService.userRole[0].groupId,
        displayExp: this.qualityService.userRole[0].groupName
      }];
      this.qualityService.SelectedGroupNameAndValue = selectedGroupValue;
      this.qualityService.groupNameAndValue = selectedGroupValue;
      if (this.qualityService.userRole[0]?.qmsRoles.includes("Auditor")) {
        this.qualityService.loggedAuditor = true;
      } else {
        this.qualityService.loggedAuditor = false;
      }

      this.auService.list = {};
      this.message.activityId = this.qualityService.activityId = this.auService.list.AU_NO = audit.auNo;
      this.qualityService.selectedGroup = this.qualityService.selectedActivityGroupId = this.auService.list.GROUP_ID = audit.groupId;
      this.message.breadcrumbData.secondLevel = "Audit" + " > " + selectedGroupValue[0].displayExp;
      this.message.breadcrumbData.fourthLevel = this.auService.list.AU_ID = audit.auId;
      this.qualityService.activity = {};
      this.qualityService.activity.status = this.auService.list.STATUS = audit.status;
      this.qualityService.getQmsActionDataUsingById = {};
      this.appService.getQmsGroupsByModule("AU").subscribe((response1: any) => {
        const dropDownForAuditGroup = response1;
        this.auService.priorGroup = dropDownForAuditGroup.find((item: any) => item.groupId == audit.groupId);
        this.qualityService.auditEditmodeDatas = { pageName: "Audit Plan" };
        this.isProcessing = false;
        this.coreNavigationService.calenderNavigation = 'Audit Grid';
      });
    });
  }

  private navigateToConduct(audit: any): void {
    this.coreNavigationService.navigationSource = 'Home';
    this.qualityService.activityDynamicButtonList = [];
    this.auService.tabName = 'Conduct Audit';
    this.qualityService.auditEditmodeDatas = { pageName: "Conduct Audit" };

    this.appService.getQmsGroupDetailsByModule(audit.groupId, this.qualityService.moduleName).subscribe((data1: any) => {
      this.qualityService.selectedGroupDetailData = data1;
    });

    this.appService.getQmsActiveUserByGroupIdModuleUserId(audit.groupId, this.qualityService.moduleName).subscribe((response1: any) => {
      this.qualityService.userRole = response1;
      const selectedGroupValue = [{
        valueExp: this.qualityService.userRole[0].groupId,
        displayExp: this.qualityService.userRole[0].groupName
      }];
      this.qualityService.SelectedGroupNameAndValue = selectedGroupValue;
      this.qualityService.groupNameAndValue = selectedGroupValue;
      this.qualityService.selectedGroupDetailId = response1[0].groupDetailId;
      if (this.qualityService.userRole[0]?.qmsRoles.includes("Auditor")) {
        this.qualityService.loggedAuditor = true;
      } else {
        this.qualityService.loggedAuditor = false;
      }

      this.qualityService.auditEditmodeDatas = { pageName: "Conduct Audit" };
      let list: any = {};
      this.message.activityId = this.qualityService.activityId = list.AU_NO = audit.auNo;
      this.qualityService.selectedGroup = this.qualityService.selectedActivityGroupId = list.GROUP_ID = audit.groupId;
      this.message.breadcrumbData.secondLevel = "Audit" + " > " + selectedGroupValue[0].displayExp;
      this.message.breadcrumbData.fourthLevel = list.AU_ID = audit.auId;
      this.qualityService.activity = {};
      this.qualityService.activity.status = list.STATUS = audit.status;
      this.qualityService.getQmsActionDataUsingById = {};
      this.isProcessing = false;
      this.router.navigate(['/dashboard/auDetailPage']);
    });
  }

  private navigateToTrainingDashboard(): void {
    this.appService.myTraining = "mainPage"
    this.router.navigate(['/dashboard/trainingDashboard']);
  }



  isShowDueDate: boolean = false;
  dueDate: any;
  password: any;

  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

}







